import { IndividualRoomRateAvailability, RoomRateAvailability } from 'shared-types/Room';
import { Moment } from 'moment';
import moment from 'moment-timezone';

export const getMatchingDay = (
  availability: RoomRateAvailability,
  currentDay: Moment
): IndividualRoomRateAvailability | undefined =>
  availability?.find((availableDay) => currentDay.isSame(moment(availableDay.date), 'D'));
